import React from 'react';
import { Box } from '@mui/material';
import ScoreEntryTeamHeader from './ScoreEntryTeamHeader';
import PlayerScoreEntry from './PlayerScoreEntry';

const TeamScoreEntry = ({
    team,
    playerState,
    setPlayerState,
    round,
    eventId,
    event,
    invalidEntries,
    setInvalidEntries,
    completedTeams,
    setCompletedTeams,
}) => {
    const teamLogo = team?.teamLogo;
    const teamName = team?.teamName;
    const teamId = team?.teamId;
    const teamScore = team?.scores?.[eventId]?.score ?? 'TBD';
    const eventIdString = eventId?.toString();
    const eventPar = event?.par || 0;
    //console.log("Event Par", eventPar);
    //console.log("Team Score Entry", teamLogo, teamName, teamId, team, "Event", event, "Team Score", teamScore);   

    const teamPlayers = playerState?.filter(player => player.teamId === teamId);
    //console.log("Team Players", teamPlayers);

    const roundKey = `round${round}`;

    // Count how many players have a score for the event
    const playersWithScore = teamPlayers?.filter(player => player.scores?.[eventId]?.[roundKey] !== undefined)?.length || 0;
    //console.log("Players With Score", playersWithScore);

    return (
        <Box>
            <ScoreEntryTeamHeader 
                teamLogo={teamLogo}
                scoresEntered={playersWithScore}
                totalPlayers={teamPlayers?.length}
                teamScore={teamScore}
                completedTeams={completedTeams}
                setCompletedTeams={setCompletedTeams}
                teamId={teamId}
            />

            {teamPlayers?.map((player, index) => {
                const playerName = `${player?.firstName} ${player?.lastName}`;
                //console.log("Round Key", roundKey, "eventIdString", eventIdString);
                const playerScore = player?.scores?.[eventIdString]?.[roundKey] || null;
                const playerId = player?.playerId;
                //console.log("Player", player, "Player Score", playerScore, "Player ID", playerId);

                return (
                    <PlayerScoreEntry 
                        key={index}
                        playerId={playerId}
                        playerName={playerName}
                        playerScore={playerScore}
                        playerState={playerState}
                        setPlayerState={setPlayerState}
                        eventId={eventIdString}
                        roundKey={roundKey}
                        invalidEntries={invalidEntries}
                        setInvalidEntries={setInvalidEntries}
                        par={eventPar}
                    />
                )
            })}
        </Box>
    );
}

export default TeamScoreEntry;